import React, { useCallback } from "react";
import "./Auth.css";
import { LANDING_AUTH_LAYOUT_KEYS } from "../../utils/translation-constants";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import config from "custom/config/environment";
import { setAppLanguage } from "../../store/actions/app.actions";
import i18next from "i18next";
import { getLanguageSelector } from "../../store/selectors/app.selector";

export default function AuthStaticLayout({ children }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedLng = useSelector(getLanguageSelector);

  const handleLanguage = useCallback((e) => {
    try {
      const { value } = e.target;
      dispatch(setAppLanguage(value));
      i18next.changeLanguage(value);
    } catch (err) {}
  }, []);

  return (
    <div className="row auth-layout-section" style={{ overflow: "auto" }}>
      <div
        className="col-xs-12 col-sm-5 col-md-5 col-xl-5 col-lg-5"
        style={{ height: "100vh" }}
      >
        {config.LANGUAGE_SELECTION && (
          <div className="language-selection">
            <select
              onChange={handleLanguage}
              value={selectedLng}
              placeholder="Choose Language"
            >
              {config.LANGUAGE_LIST.map((option, index) => (
                <option value={option} key={index}>
                  {option.toLocaleUpperCase()}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="auth-render-section h-100 d-flex flex-column">
          <div className="text-center">
            <div className="auth-logo"></div>
          </div>
          <div>{children}</div>
          <div></div>
        </div>
      </div>
      <div className="col-7 oval-static d-none d-sm-block d-md-block d-xl-block d-lg-block">
        {/* <div className="slogan">
          <div className="title1">
            <h3>{t(LANDING_AUTH_LAYOUT_KEYS.SLOGAN_1)}</h3>
            <h1>{t(LANDING_AUTH_LAYOUT_KEYS.SLOGAN_2)}</h1>
          </div>
          <div className="title2" style={{ marginLeft: 140 }}>
            <h3>{t(LANDING_AUTH_LAYOUT_KEYS.SLOGAN_3)}</h3>
            <h1>{t(LANDING_AUTH_LAYOUT_KEYS.SLOGAN_4)}</h1>
          </div>
        </div> */}
      </div>
    </div>
  );
}
